import { useRequireAuth } from '@/hooks';
import { useSelector } from 'react-redux';
import { isAuthenticatedSelector } from '@/redux/auth';

const NotFound = () => {
  useRequireAuth(useSelector(isAuthenticatedSelector));

  return (
    <main className="grow flex">
      <div className="max-w-[1440px] m-auto py-8 px-4 text-center">
        <div className="text-gray-300 font-black leading-none mb-2">
          <div className="text-9xl">404</div>
          <div className="text-6xl">Not Found</div>
        </div>
        <h1 className="text-3xl mb-2">The page you are looking for does not exist.</h1>
        <p>If you believe this is an error, please contact an administrator.</p>
      </div>
    </main>
  );
};

export default NotFound;
